<prlw-file-upload-overlay-ui
  (closeOverlay)="onCloseOverlay()"
></prlw-file-upload-overlay-ui>
